export interface SEOConfig {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
}

export const updatePageSEO = (config: SEOConfig) => {
  // Update title
  document.title = config.title;

  // Update or create meta tags
  const updateMetaTag = (name: string, content: string, property = false) => {
    const attribute = property ? 'property' : 'name';
    let element = document.querySelector(`meta[${attribute}="${name}"]`);
    
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attribute, name);
      document.head.appendChild(element);
    }
    
    element.setAttribute('content', content);
  };

  // Update description
  updateMetaTag('description', config.description);
  
  // Update keywords if provided
  if (config.keywords) {
    updateMetaTag('keywords', config.keywords);
  }

  // Update canonical URL if provided
  if (config.canonical) {
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', config.canonical);
  }

  // Update Open Graph tags
  updateMetaTag('og:title', config.title, true);
  updateMetaTag('og:description', config.description, true);
  if (config.canonical) {
    updateMetaTag('og:url', config.canonical, true);
  }
  if (config.ogImage) {
    updateMetaTag('og:image', config.ogImage, true);
  }

  // Update Twitter tags
  updateMetaTag('twitter:title', config.title);
  updateMetaTag('twitter:description', config.description);
  if (config.ogImage) {
    updateMetaTag('twitter:image', config.ogImage);
  }

  // Update last-modified
  const today = new Date().toISOString().split('T')[0];
  updateMetaTag('last-modified', today);
};
